export const TERMINAL_DEFAULT_TAX = {
  addDTTLink: document.querySelector('#aafp_terminal-tax-form') as HTMLFormElement,
  updateDTTLink: document.querySelector('#aafp_update-tcg-form') as HTMLFormElement,
  partnerName: document.querySelector('#aafp_tax-partner-name') as HTMLInputElement,
  terminalName: document.querySelector('#aafp_tax-terminal-name') as HTMLInputElement,
  searchInputCon: document.querySelector('.aafp_text-field') as HTMLElement,
  searchInput: document.querySelector('#aafp_tax-input') as HTMLInputElement,
  searchClear:  document.querySelector('.aafp_clear-search') as HTMLElement,
  searchButton: document.querySelector('#aafp_cardgroup-find') as HTMLElement,
  searchResults: document.querySelector('.aafp_tax-search-result') as HTMLElement,
  searchSelected: document.querySelector('.aafp_tax-selected') as HTMLElement,
  taxSelected: document.querySelector('.aafp_tax-selected') as HTMLElement,
  submitButton: document.querySelector('#aafp_cgt-submit') as HTMLButtonElement
}